import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledAudioUploadSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  flex: 1;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;

const TipsBox = styled(Box)`
  width: 100%;
  display: flex;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid ${COLOR.secondary[16]};
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export { StyledAudioUploadSection, TipsBox };
